import * as Yup from 'yup';

export const knowledgeValidationSchema = Yup.object().shape({
  title: Yup.string()
    .required('กรุณากรอกชื่อบทเรียน')
    .min(3, 'ชื่อบทเรียนต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(100, 'ชื่อบทเรียนต้องไม่เกิน 100 ตัวอักษร'),
  
  description: Yup.string()
    .max(500, 'คำอธิบายบทเรียนต้องไม่เกิน 500 ตัวอักษร'),
  
  duration: Yup.number()
    .required('กรุณากรอกระยะเวลา')
    .min(0, 'ระยะเวลาต้องไม่น้อยกว่า 0 นาที')
    .max(480, 'ระยะเวลาต้องไม่เกิน 480 นาที'),
  
  category: Yup.string()
    .required('กรุณาเลือกหมวดหมู่'),
  
  videoUrl1: Yup.string()
    .required('กรุณากรอกลิงก์วิดีโอหลัก')
    .url('กรุณากรอกลิงก์วิดีโอให้ถูกต้อง'),
  
  videoUrl2: Yup.string()
    .nullable()
    .url('กรุณากรอกลิงก์วิดีโอให้ถูกต้อง'),
  
  status: Yup.string()
    .required('กรุณาเลือกสถานะ')
    .oneOf(['DRAFT', 'PUBLISHED'], 'กรุณาเลือกสถานะให้ถูกต้อง'),
  
  isActive: Yup.boolean()
    .required('กรุณาเลือกสถานะการใช้งาน')
}); 